export const INTEGRATIONS_SORT_TYPES = {
    alphabetical: 'name',
    created: '-created_at', // most recent first
};

export const INTEGRATIONS_TYPES_LABELS = {
    alphabetical: 'Alphabetical',
    created: 'Most Recently Created',
};
